export default __webpack_public_path__ + "static/media/kickstarter.cd37ade7.svg";